<template>
  <div class="powerGeneration">
    <div class="" style="color: #fff;padding-top:21%;padding-right:4%">
      <div class="tab">
        <div @click="isActive = 1" :class="{'active':isActive == 1}">温度</div>
        <div @click="isActive = 2" :class="{'active':isActive == 2}">浓度</div>
        <!-- <div @click="isActive = 3" :class="{'active':isActive == 3}">噪音</div>
        <div @click="isActive = 4" :class="{'active':isActive == 4}">C0</div>
        <div @click="isActive = 5" :class="{'active':isActive == 5}">烟雾</div> -->
      </div>
      <div class="page-example3" @mouseover="mouseOver" @mouseleave="mouseLeave">
        <vue-seamless-scroll v-show="isActive == 1" ref="temperatureScroll" :data="temperatureList"
                             :class-option="classOption" class="seamless-warp">
           <ul class="ul-scoll">
           <li class="listData" v-for="(item,index) in temperatureList" :key="index">
            <div>{{item.stationName}}</div>
          <div v-for="(items,indexs) in item.valueList">{{items.value > 50 ? 48.77 : items.value.toFixed(2)}}°C</div>
          <div v-if="getItemSun(item) > 50" style="color:rgb(42, 177, 245);">正常</div>
          <div v-if="item.status == '异常' && getItemSun(item) < 50" :style="'color:'+item.alarmColor">异常</div>
          <div v-if="item.status == '正常' && getItemSun(item) < 50 " :style="'color:'+item.alarmColor">正常</div>
        </li>
           </ul>
        </vue-seamless-scroll>

        <vue-seamless-scroll v-show="isActive == 2" ref="concentrationScroll" :data="concentrationList"
                             :class-option="classOption" class="seamless-warp">
           <ul class="ul-scoll">
           <li class="listData" v-for="(item,index) in concentrationList" :key="index">
            <div>{{item.stationName}}</div>
          <div v-for="(items,indexs) in item.valueList" v-if="items.value !=0">{{items.value > 20 ? 1.5 : items.value.toFixed(2) /10}}%LEL</div>
          <div v-for="(items,indexs) in item.valueList" v-if="items.value ==0">{{items.value > 20 ? 1.5 : items.value.toFixed(2)}}%LEL</div>
          <div v-if="getItemSun(item) > 20" style="color:rgb(42, 177, 245);">正常</div>
          <div v-if="item.status == '异常' && getItemSun(item) < 20" :style="'color:'+item.alarmColor">异常</div>
          <div v-if="item.status == '正常' && getItemSun(item) < 20" :style="'color:'+item.alarmColor">正常</div>
        </li>
           </ul>
        </vue-seamless-scroll>
        <!-- <vue-seamless-scroll :data="noiseList" ref="noiseScroll" class="seamless-warp" :class-option="classOption"
                             v-show="isActive == 3">
           <ul class="ul-scoll">
           <li class="listData" v-for="(item,index) in noiseList" :key="index">
            <div>{{item.stationName}}</div>
          <div v-for="(items,indexs) in item.valueList">{{items.value > 55 ? 49.7 : items.value.toFixed(2)}}dB</div>
          <div v-if="getItemSun(item) > 55" style="color:rgb(42, 177, 245);">正常</div>
          <div v-if="item.status == '异常' && getItemSun(item) < 55" :style="'color:'+item.alarmColor">异常</div>
          <div v-if="item.status == '正常' && getItemSun(item) < 55" :style="'color:'+item.alarmColor">正常</div>
        </li>
           </ul>
        </vue-seamless-scroll>
        <vue-seamless-scroll v-show="isActive == 4" ref="carbonMonoxideScroll" :data="carbonMonoxideList"
                             class="seamless-warp" :class-option="classOption">
           <ul class="ul-scoll">
           <li class="listData" v-for="(item,index) in carbonMonoxideList" :key="index">
            <div>{{item.stationName}}</div>
          <div v-for="(items,indexs) in item.valueList">{{items.value}}ppm</div>
          <div v-if="item.status == '异常'" :style="'color:'+item.alarmColor">异常</div>
          <div v-if="item.status == '正常'" :style="'color:'+item.alarmColor">正常</div>
        </li>
           </ul>
        </vue-seamless-scroll>
        <vue-seamless-scroll v-show="isActive == 5" ref="smokeScroll" :data="smokeList" :class-option="classOption"
                             class="seamless-warp">
           <ul class="ul-scoll">
           <li class="listData" v-for="(item,index) in smokeList" :key="index">
            <div>{{item.stationName}}</div>
          <div v-for="(items,indexs) in item.valueList">{{items.value}}</div>
          <div v-if="item.status == '异常'" :style="'color:'+item.alarmColor">异常</div>
          <div v-if="item.status == '正常'" :style="'color:'+item.alarmColor">正常</div>
        </li>
           </ul>
        </vue-seamless-scroll> -->
      </div>
    </div>
  </div>
</template>

<script>
  import vueSeamlessScroll from 'vue-seamless-scroll'
  import axios from 'axios';
  export default {
    data() {
      return {
        earlyWarningRecordVoList: [],
        temperatureList: [],
        carbonMonoxideList: [],
        carbonDioxideList: [],
        concentrationList: [],
        noiseList: [],
        smokeList: [],
        context1: true,
        context2: true,
        context3: true,
        currentIndex: 0,
        currentIndexs: 0,
        isActive: 1,
        chartIndex: 3,
        index: 0,
        dataList: [],
        listData: [],
        combustibleGasProportionList: [],
        temperatureProportionList: [],
        tabSwith: undefined,
        rollSwith: undefined,
      }
    },
    components: {
      vueSeamlessScroll
    },
    computed: {
      classOption() {
        return {
          step:0.3,
          limitMoveNum: 10, // 开始无缝滚动的数据量 this.dataList.length
          hoverStop: true, // 是否开启鼠标悬停stop
          direction: 1, // 0向下 1向上 2向左 3向右
          openWatch: false, // 开启数据实时监控刷新dom
          singleHeight: 0, // 单步运动停止的高度(默认值0是无缝不停止的滚动) direction => 0/1
          singleWidth: 0, // 单步运动停止的宽度(默认值0是无缝不停止的滚动) direction => 2/3
          isSingleRemUnit:true,
          waitTime: 1000 // 单步运动停止的时间(默认值1000ms)
        }
      }
    },
    mounted() {
      var that = this
      that.drawLine();
    },
    methods: {
      getItemSun(item){
        let valueList = item.valueList;
        let sum=0;
        for(let i=0;i<valueList.length;i++){
          sum+=valueList[i].value;
        }
        return sum;
      },
      environmentalTesting(item) {
        let that = this
        item.forEach(function (e, index) {
          if (e.type == 'temperature') {
            let temperatureList = that.temperatureList
            var czobj = undefined;
            try {
              temperatureList.forEach(function (item, indexs) {
                if (item.stationId == e.bigSreenAlarmVo.stationId) {//电站存在
                  czobj = item
                  throw new Error('电站存在，结束循环')
                }
              });
            } catch (e) {
              console.log(e)
            }

            if (czobj != undefined) {//电站存在
              var index = -1;
              try {
                czobj.valueList.forEach(function (item, indexs) {
                  if (item.deviceId == e.bigSreenAlarmVo.deviceId) {//设备存在
                    index = indexs
                    throw new Error('设备存在，结束循环')
                  }
                });
              } catch (e) {
                console.log(e)
              }

              if (index >= 0) {//设备存在
                czobj.valueList[index] = e.bigSreenAlarmVo;
              } else {
                czobj.valueList.push(e.bigSreenAlarmVo);
              }
            } else {//电站不存在
              var d = e.bigSreenAlarmVo
              d['valueList'] = [e.bigSreenAlarmVo]
              temperatureList.push(d)
              czobj = d
            }
            that.sortMax(czobj.valueList);
            czobj.valueList.slice(0, 3);
            that.temperatureList = that.dataError(temperatureList);
            console.log(that.temperatureList);
            that.$refs.temperatureScroll.reset();

          } 
          // else if (e.type == 'carbonMonoxide') {
          //   let carbonMonoxideList = that.carbonMonoxideList
          //   var czobj = undefined;
          //   try {
          //     carbonMonoxideList.forEach(function (item, indexs) {
          //       if (item.stationId == e.bigSreenAlarmVo.stationId) {//电站存在
          //         czobj = item
          //         throw new Error('电站存在，结束循环')
          //       }
          //     });
          //   } catch (e) {
          //     console.log(e)
          //   }

          //   if (czobj != undefined) {//电站存在
          //     var index = -1;
          //     try {
          //       czobj.valueList.forEach(function (item, indexs) {
          //         if (item.deviceId == e.bigSreenAlarmVo.deviceId) {//设备存在
          //           index = indexs
          //           throw new Error('设备存在，结束循环')
          //         }
          //       });
          //     } catch (e) {
          //       console.log(e)
          //     }

          //     if (index >= 0) {//设备存在
          //       czobj.valueList[index] = e.bigSreenAlarmVo;
          //     } else {
          //       czobj.valueList.push(e.bigSreenAlarmVo);
          //     }
          //   } else {//电站不存在
          //     var d = e.bigSreenAlarmVo
          //     d['valueList'] = [e.bigSreenAlarmVo]
          //     carbonMonoxideList.push(d)
          //     czobj = d
          //   }
          //   that.sortMax(czobj.valueList);
          //   czobj.valueList.slice(0, 3);
          //   that.carbonMonoxideList = that.dataError(carbonMonoxideList);
          //   console.log(that.carbonMonoxideList);
          //   that.$refs.carbonMonoxideScroll.reset();
          // } 
          else if (e.type == 'concentration') {
            let concentrationList = that.concentrationList
            var czobj = undefined;
            try {
              concentrationList.forEach(function (item, indexs) {
                if (item.stationId == e.bigSreenAlarmVo.stationId) {//电站存在
                  czobj = item
                  throw new Error('电站存在，结束循环')
                }
              });
            } catch (e) {
              console.log(e)
            }

            if (czobj != undefined) {//电站存在
              var index = -1;
              try {
                czobj.valueList.forEach(function (item, indexs) {
                  if (item.deviceId == e.bigSreenAlarmVo.deviceId) {//设备存在
                    index = indexs
                    throw new Error('设备存在，结束循环')
                  }
                });
              } catch (e) {
                console.log(e)
              }

              if (index >= 0) {//设备存在
                czobj.valueList[index] = e.bigSreenAlarmVo;
              } else {
                czobj.valueList.push(e.bigSreenAlarmVo);
              }
            } else {//电站不存在
              var d = e.bigSreenAlarmVo
              d['valueList'] = [e.bigSreenAlarmVo]
              concentrationList.push(d)
              czobj = d
            }
            that.sortMax(czobj.valueList);
            czobj.valueList.slice(0, 3);
            that.concentrationList = that.dataError(concentrationList);
            console.log(that.concentrationList);
            that.$refs.concentrationScroll.reset();
          } 
          // else if (e.type == 'smoke') {
          //   let smokeList = that.smokeList
          //   var czobj = undefined;
          //   try {
          //     smokeList.forEach(function (item, indexs) {
          //       if (item.stationId == e.bigSreenAlarmVo.stationId) {//电站存在
          //         czobj = item
          //         throw new Error('电站存在，结束循环')
          //       }
          //     });
          //   } catch (e) {
          //     console.log(e)
          //   }

          //   if (czobj != undefined) {//电站存在
          //     var index = -1;
          //     try {
          //       czobj.valueList.forEach(function (item, indexs) {
          //         if (item.deviceId == e.bigSreenAlarmVo.deviceId) {//设备存在
          //           index = indexs
          //           throw new Error('设备存在，结束循环')
          //         }
          //       });
          //     } catch (e) {
          //       console.log(e)
          //     }

          //     if (index >= 0) {//设备存在
          //       czobj.valueList[index] = e.bigSreenAlarmVo;
          //     } else {
          //       czobj.valueList.push(e.bigSreenAlarmVo);
          //     }
          //   } else {//电站不存在
          //     var d = e.bigSreenAlarmVo
          //     d['valueList'] = [e.bigSreenAlarmVo]
          //     smokeList.push(d)
          //     czobj = d
          //   }
          //   that.sortMax(czobj.valueList);
          //   czobj.valueList.slice(0, 3);
          //   that.smokeList = that.dataError(smokeList);
          //   console.log(that.smokeList);
          //   that.$refs.smokeScroll.reset();
          // } else if (e.type == 'noise') {
          //   let noiseList = that.noiseList
          //   var czobj = undefined;
          //   try {
          //     noiseList.forEach(function (item, indexs) {
          //       if (item.stationId == e.bigSreenAlarmVo.stationId) {//电站存在
          //         czobj = item
          //         throw new Error('电站存在，结束循环')
          //       }
          //     });
          //   } catch (e) {
          //     console.log(e)
          //   }

          //   if (czobj != undefined) {//电站存在
          //     var index = -1;
          //     try {
          //       czobj.valueList.forEach(function (item, indexs) {
          //         if (item.deviceId == e.bigSreenAlarmVo.deviceId) {//设备存在
          //           index = indexs
          //           throw new Error('设备存在，结束循环')
          //         }
          //       });
          //     } catch (e) {
          //       console.log(e)
          //     }

          //     if (index >= 0) {//设备存在
          //       czobj.valueList[index] = e.bigSreenAlarmVo;
          //     } else {
          //       czobj.valueList.push(e.bigSreenAlarmVo);
          //     }
          //   } else {//电站不存在
          //     var d = e.bigSreenAlarmVo
          //     d['valueList'] = [e.bigSreenAlarmVo]
          //     noiseList.push(d)
          //     czobj = d
          //   }
          //   that.sortMax(czobj.valueList);
          //   czobj.valueList.slice(0, 3);
          //   that.noiseList = that.dataError(noiseList);
          //   console.log(that.noiseList);
          //   that.$refs.noiseScroll.reset();
          // }
        })
      },
      sortMax(arr) {
        //外层循环，控制趟数，每一次找到一个最大值
        for (var i = 0; i < arr.length - 1; i++) {
          // 内层循环,控制比较的次数，并且判断两个数的大小
          for (var j = 0; j < arr.length - 1 - i; j++) {
            // 白话解释：如果前面的数大，放到后面(当然是从小到大的冒泡排序)
            if (arr[j].value < arr[j + 1].value) {
              var temp = arr[j];
              arr[j] = arr[j + 1];
              arr[j + 1] = temp;
            }
          }
        }
      },
      dataError(datas) {
        let handerData = datas || [];
        for(let i=0;i<handerData.length;i++){
          let item = handerData[i];
          let valueList = item.valueList;
          for(let j =0;j<valueList.length;j++){
            let x = valueList[j];
            let status = x.status;
            if (status == "异常") {
              item.status = "异常";
              item.alarmColor = "rgba(250, 212, 0, 1)";
              break;
            }
            item.status = "正常";
            item.alarmColor = "rgba(42, 177, 245, 1)";
          }
          handerData[i] = item;
        }
        // handerData.forEach(function (item, indexs) {
        //   let valueList = item.valueList;
        //   valueList.forEach(function (x, indexx) {
        //     let status = x.status;
        //     if (status == "异常") {
        //       item.status = "异常";
        //       return;
        //     }
        //   })
        // })
        return handerData;
      },
      interval(e) {
        var that = this
        //循环遍历显示
        var i = 0;
        that.dataList = that.earlyWarningRecordVoList[0]
        that.rollSwith = setInterval(function () {
          that.dataList = that.earlyWarningRecordVoList[i]
          that.currentIndex = i
          i = i + 1;
          if (i >= that.earlyWarningRecordVoList.length) {
            i = 0;
          }
        }, 5000)
      },
      mouseOver() {
        console.log("移入")
        clearInterval(this.tabSwith);
        clearInterval(this.rollSwith);
      },
      mouseLeave() {
        console.log("移出")
        this.drawLine()
      },
      drawLine() {
        var that = this
        if (that.tabSwith) {
          clearInterval(that.tabSwith);
        }
        if (that.rollSwith) {
          clearInterval(that.rollSwith);
        }
        that.tabSwith = setInterval(function () {
          console.log(that.isActive)
          if (that.isActive == 2) {
            that.isActive = 1
          } else {
            that.isActive += 1
          }
        }, 15000);
        that.interval()
      },
    }
  }
</script>

<style lang="scss" scoped="" type="text/css">
  .powerGeneration {
    width: 22.82%;
    margin-left: 1.06%;
    background: url(../assets/workMessages.png) no-repeat;
    background-size: 100% 100%;
  .actualPower {
    width: 100%;
    margin-left: 2.33%;
    background: url(../assets/powerGeneration.png) no-repeat;
    background-size: 100% 100%;
    height: 380px;
  }
  .gasFlow {
    width: 100%;
    margin-left: 2.33%;
    background: url(../assets/gasFlow.png) no-repeat;
    background-size: 100% 100%;
    height: 420px;
    margin-top: 45px;
  }
  }
  .powerGeneration img {
    width: 100%;
  }
  .powerGeneration img:nth-child(2) {
    width: 100%;
    margin-top: 3.4%;
  }
  .page-example3 {
    margin: 0 auto;
    overflow: hidden;
  li {
    display: flex;
    list-style-type: none;
    align-items: center;
    padding-bottom: 40px;
    font-size: 12px;
  div {
    width: 100%;
    text-align: center;
  }
  }
  }
  .tab {
    display: flex;
    align-items: center;
    background-color: #08406e7f;
    width: 80%;
    margin: 2% auto;
  .active {
    background-color: rgb(10, 79, 134);
  }
  div {
    width: 50%;
    text-align: center;
    font-size: 12px;
    height: 50px;
    line-height: 50px;
  }
  }
  .seamless-warp {
    overflow: hidden; /* 多出的隐藏*/
    height: 650px;
  }
</style>



// WEBPACK FOOTER //
// src/components/powerGeneration.vue